import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import toastHelper from "../../Util/toastHelper";
import API from "../../API/API";
import axios from "axios";

export const getAllAssets = createAsyncThunk(
  "assets/getAllAssets",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllAssets.url,
        method: API.admin.getAllAssets.method,
      });
      return data?.assets;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addAsset = createAsyncThunk(
  "assets/addAsset",
  async (
    params: {
      assetCode: string;
      assetName: string;
      description: string;
      serialNumber: string;
      modelNumber: string;
      status: string;
      buildingId: number;
      amenityId: number;
      assetTypeId: number;
      assetSubTypeId: number | null;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addAsset.url,
        method: API.admin.addAsset.method,
        data: params,
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateAsset = createAsyncThunk(
  "assets/updateAsset",
  async (
    params: {
      assetId: number;
      assetCode: string;
      assetName: string;
      description: string;
      serialNumber: string;
      modelNumber: string;
      status: string;
      buildingId: number;
      amenityId: number;
      assetTypeId: number;
      assetSubTypeId: number | null;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateAsset.url,
        method: API.admin.updateAsset.method,
        data: {
          assetId: params.assetId,
          assetCode: params.assetCode,
          assetName: params.assetName,
          description: params.description,
          serialNumber: params.serialNumber,
          modelNumber: params.modelNumber,
          status: params.status,
          buildingId: params.buildingId,
          amenityId: params.amenityId,
          assetTypeId: params.assetTypeId,
          assetSubTypeId: params.assetSubTypeId,
        },
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const changeComplaintStatus = createAsyncThunk(
  "assets/changeComplaintStatus",
  async (
    params: { complaintId: number; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.changeComplaintStatus.url+params?.complaintId,
        method: API.admin.changeComplaintStatus.method,
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addMemberComplaint = createAsyncThunk(
  "assets/addMemberComplaint",
  async (
    params: {
      typeId: string;
      amenityId: string | null;
      serialNumber: string | null;
      comments: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.members.addMemberComplaint.url,
        method: API.members.addMemberComplaint.method,
        data: params,
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllAssetsTypes = createAsyncThunk(
  "assets/getAllAssetsTypes",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllAssetsTypes.url,
        method: API.admin.getAllAssetsTypes.method,
      });
      return data?.assetTypes;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAllParentAssetTypes = createAsyncThunk(
  "assets/getAllParentAssetTypes",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllParentAssetTypes.url,
        method: API.admin.getAllParentAssetTypes.method,
      });
      return data?.assetTypes;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAssetSubTypesByAssetTypeId = createAsyncThunk(
  "assets/getAssetSubTypesByAssetTypeId",
  async (params: { assetTypeId: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllSubAssetTypesByParentId.url + params?.assetTypeId,
        method: API.admin.getAllSubAssetTypesByParentId.method,
      });
      return data?.assetTypes;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetAssetSubTypesByAssetTypeId = createAction(
  "assets/clearGetAssetSubTypesByAssetTypeId",
);

export const getAssetTypeById = createAsyncThunk(
  "assets/getAssetTypeById",
  async (params: { assetTypeId: number }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAssetTypeById.url + params?.assetTypeId,
        method: API.admin.getAssetTypeById.method,
      });
      return data?.assetType;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addAssetType = createAsyncThunk(
  "assets/addAssetType",
  async (
    params: {
      type: string;
      parentTypeId: number | null;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addAssetType.url,
        method: API.admin.addAssetType.method,
        data: {
          type: params.type,
          parentTypeId: params.parentTypeId,
        },
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateAssetType = createAsyncThunk(
  "assets/updateAssetType",
  async (
    params: {
      type: string;
      parentTypeId: number | null;
      assetTypeId: number;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateAssetType.url,
        method: API.admin.updateAssetType.method,
        data: {
          type: params.type,
          parentTypeId: params.parentTypeId,
          assetTypeId: params.assetTypeId,
        },
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAssetById = createAsyncThunk(
  "assets/getAssetById",
  async (params: { assetId: number }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAssetById.url + params?.assetId,
        method: API.admin.getAssetById.method,
      });
      return data?.asset;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteAssetType = createAsyncThunk(
  "assets/deleteAssetType",
  async (
    params: { assetTypeId: string; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteAssetType.url + params?.assetTypeId,
        method: API.admin.deleteAssetType.method,
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const deleteAsset = createAsyncThunk(
  "assets/deleteAsset",
  async (
    params: { assetId: string; successHandler: () => void },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.deleteAsset.url + params?.assetId,
        method: API.admin.deleteAsset.method,
      });
      toastHelper.success(data?.message);
      params?.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getMemberComplaints = createAsyncThunk(
  "assets/getMemberComplaints",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.members.getMemberComplaints.url,
        method: API.members.getMemberComplaints.method,
      });
      return data?.tickets;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getAdminComplaints = createAsyncThunk(
  "assets/getAdminComplaints",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.adminComplaints.url,
        method: API.admin.adminComplaints.method,
      });
      return data?.tickets;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const clearGetAllAssets = createAction("assets/clearGetAllAssets");
export const clearGetAllAssetsTypes = createAction(
  "assets/clearGetAllAssetsTypes",
);
